import { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import { feePayment } from "../../actions/payment.action";
import { Loading } from "../../utils/helpers/constants";
import RoundLoader from "../loader/RoundLoader";
import { AiOutlineCreditCard } from "react-icons/ai";

export default function FeePaymentModal({
  open,
  setOpen,
  cancelButtonRef,
  message,
}) {
  const dispatch = useDispatch();

  console.log({ message });

  const handleSubmit = () => {
    const baseUrl = window.location.origin;
    console.log("baseUrl  ", baseUrl);
    const payload = {
      paymentGateway: "FLUTTERWAVE",
      redirectUrl: baseUrl + "/payment/verify-payment",
      paymentChannel: "BANK_ACCOUNT",
      transactionType: "BANK_TRANSFER",
    };
    console.log("processing payment...", payload);
    dispatch(feePayment(payload));
  };

  const {
    student: { fileUploadLoading },
  } = useSelector(({ studentReducer }) => ({
    student: studentReducer,
  }));

  const loadState = fileUploadLoading === Loading.FETCHING;

  return (
    <div>
      {loadState ? (
        <RoundLoader />
      ) : (
        <Transition.Root show={open} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            initialFocus={cancelButtonRef}
            onClose={setOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg text-center overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div>
                        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-20 w-20 rounded-full bg-green-100">
                          <AiOutlineCreditCard className="h-8 w-8 text-green-600" />
                        </div>
                        <div className="mt-3 text-center">
                          <h3
                            className="text-lg md:text-xl leading-6 font-medium text-gray-900 font-bold"
                            id="modal-title"
                          >
                            {message}
                          </h3>
                          {/* <div className="mt-4">
                            <p className="text-sm md:text-lg text-gray-500">
                              Pay your alumni fee to activate your account.
                            </p>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() => handleSubmit()}
                      >
                        Pay
                      </button>
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() => setOpen(false)}
                        ref={cancelButtonRef}
                      >
                        Cancel
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
    </div>
  );
}
